import axios from 'axios';

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://www.petsidtag.com',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});
const apiClient2 = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL2 || 'https://www.petsidtag.com',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});
const clientId = process.env.VUE_APP_CLIENT_ID;
const googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      };
    }

    console.log('Request sent:', config);
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

apiClient2.interceptors.request.use(
  (config) => {
    const tenantId = process.env.VUE_APP_TENANT_ID;
    const clientId = process.env.VUE_APP_CLIENT_ID;
    const token = localStorage.getItem('token');
    if (clientId) {
      config.headers.clientid = clientId;
    }
    if (tenantId) {
      config.headers.tenantId = tenantId;
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    console.log('Response received:', response);
    return response;
  },
  (error) => {
    console.error('Response error:', error);

    // 处理常见错误
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，清除token并跳转到登录页
          localStorage.removeItem('token');
          break;
        case 403:
          console.error('访问被拒绝');
          break;
        case 404:
          console.error('请求的资源不存在');
          break;
        case 500:
          console.error('服务器内部错误');
          break;
        default:
          console.error('请求失败:', error.response.data?.message || error.message);
      }
    } else if (error.request) {
      console.error('网络错误，请检查网络连接');
    } else {
      console.error('请求配置错误:', error.message);
    }

    return Promise.reject(error);
  }
);

// API 接口定义
const api = {
  // 联系我们相关接口
  contact: {
    // 提交联系表单
    submitMessage: (data) => apiClient.post('/system/official/msg', data),
  },

  // 宠物标签相关接口
  home:{
    getHomePics: () => apiClient.get('/system/official/pics/front/home'),
  },
  // 产品相关接口
  system: {
    // 获取产品列表
    getSystemPics: (type) => apiClient.get(`/system/official/pics/front/${type}`)
  },

  // 用户相关接口
  user: {
    // Google登录
    googleLogin: (data) => apiClient2.get('/api/login/callback?code=' + data+"&clientId="+clientId+"&tenantId=000000&type=pc"),
    // 获取用户信息
    login: (data) => apiClient2.post('/api/login', data),
  },

  // 验证码相关接口
  common: {
    // 发送验证码
    sendVerificationCode: (data) => apiClient2.post('/api/login/getcode', data),
  },

  // 宠物标签相关接口
  petTags: {
    // 获取用户的标签列表
    getPetTags: (uid) => apiClient2.get(`/api/pet/list/${uid}`),
  },

}

// 工具函数
const utils = {
  // 格式化错误信息
  formatError: (error) => {
    if (error.response?.data?.message) {
      return error.response.data.message;
    }
    if (error.response?.data?.error) {
      return error.response.data.error;
    }
    if (error.message) {
      return error.message;
    }
    return 'An unexpected error occurred';
  },

  // 格式化日期
  formatDate: (date, format = 'YYYY-MM-DD') => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    
    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day);
  },

  // 验证邮箱格式
  validateEmail: (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  },

  // 验证手机号格式
  validatePhone: (phone) => {
    const regex = /^[\d+]?[1-9][\d]{0,15}$/;
    return regex.test(phone);
  }
};

// 导出 API 和工具
export { api, apiClient, apiClient2, googleClientId, utils };
export default api;